import axios from "axios";
import authHeader from "./auth-header";
import { resolveApiUrl } from "../pages/http-common";

const runtimeBase = resolveApiUrl(process.env.REACT_APP_API_URL);

// centralize axios defaults
axios.defaults.baseURL = runtimeBase;
const defaultTimeout = Number(process.env.REACT_APP_API_TIMEOUT) || 60000;
axios.defaults.timeout = defaultTimeout;

const API_URL = "/auth/";

// login -> returns axios response (controller should return accessToken + roles/user)
const login = (username, password) => {
  return axios.post(API_URL + "signin", { username, password });
};

// register (keeps schema keys aligned with backend)
const register = (
  username,
  email,
  password,
  date,
  firstName,
  middleName,
  lastName,
  phoneNumber,
  sex,
  maritalStatus,
  state,
  homeTown,
  applicantsPlaceOfWork,
  applicantSignature,
  applicantDate,
  nameOfReferee,
  refereeAddress,
  refereePhoneNumber,
  refereeEmail,
  refereeSignature,
  refereeDate,
  residenceAddress,
  postalAddress,
  approvedOrNotApproved,
  dateApproved,
  registrationNo
) => {
  const payload = {
    // backend schema keys
    membershipId: null,
    username: username || null,
    email: email || null,
    password: password || null,
    date: date || null,
    firstName: firstName || null,
    middleName: middleName || null,
    lastName: lastName || null,
    phoneNumber: phoneNumber || null,
    sex: sex || null,
    maritalStatus: maritalStatus || null,
    state: state || null,
    homeTown: homeTown || null,
    applicantsPlaceOfWork: applicantsPlaceOfWork || null,
    applicantSignature: applicantSignature || null,
    applicantDate: applicantDate || null,
    nameOfReferee: nameOfReferee || null,
    refereeAddress: refereeAddress || null,
    refereePhoneNumber: refereePhoneNumber || null,
    refereeEmail: refereeEmail || null,
    refereeSignature: refereeSignature || null,
    refereeDate: refereeDate || null,
    residenceAddress: residenceAddress || null,
    postalAddress: postalAddress || null,
    approvedOrNotApproved: approvedOrNotApproved || null,
    dateApproved: dateApproved || null,
    registrationNo: registrationNo || null,
    dateOfMembership: null,
    position: null,
    guarantorFullName: null,
    guarantorMembershipId: null,
    nextOfKin: null,
    nextOfKinPhoneNumber: null
  };
  return axios.post(API_URL + "signup", payload);
};

const changePassword = (currentPassword, newPassword) => {
  return axios.post(API_URL + "change-password", { currentPassword, newPassword }, { headers: authHeader() });
};

const forgotPassword = (emailOrUsername) => {
  return axios.post(API_URL + "forgot-password", { emailOrUsername });
};

const verifyResetToken = (token) => {
  return axios.get(API_URL + `reset-password/${encodeURIComponent(token)}`);
};

const resetPassword = (token, newPassword) => {
  return axios.post(API_URL + "reset-password", { token, newPassword });
};

const authService = {
  login,
  register,
  changePassword,
  forgotPassword,
  verifyResetToken,
  resetPassword,
};

export default authService;
